import React from 'react';
import { GenericListPage } from '../../components/generic';
import { useInvoicePayments, InvoicePayment } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<InvoicePayment>
      useData={useInvoicePayments}
      config={{
        ...moduleConfig,
        getColumns: (formatDate: (dateString?: string) => string, _formatCurrency?: any, colors?: any) => getColumns(formatDate, moduleConfig.utils.formatCurrency, colors),
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;

